import React from 'react';
import { Capacitor } from '@capacitor/core';
import { Link } from 'react-router-dom';
import kidArtwork from '../../assets/icons/portal/kid-login.png';
import '../../styles/brand-typography.css';
import './KidAuthLayout.css';

// Deliberately independent of ParentTheme/Auth providers for the native Kids bundle.
export default function KidAuthLayout({ children }) {
  const brand = <><span className="font-extrabold tracking-tight text-teal-950">My<span className="text-pink-600">Piggy</span></span><span className="text-xs font-bold tracking-[0.16em] text-slate-500">Accounting</span></>;
  return (
    <div className="mypiggy-brand kid-auth min-h-screen bg-[#fcfbfc] text-slate-900">
      <header className="mx-auto flex w-full max-w-6xl items-center justify-between px-5 py-5 sm:px-8">
        {Capacitor.isNativePlatform() ? <div className="flex flex-col text-2xl leading-tight">{brand}</div> : <Link to="/" aria-label="MyPiggy Accounting home" className="flex flex-col rounded-lg text-2xl leading-tight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-700">{brand}</Link>}
        <span className="rounded-full border border-pink-100 bg-pink-50 px-3 py-1.5 text-xs font-extrabold text-pink-800">For Kids</span>
      </header>
      <main className="mx-auto grid w-full max-w-6xl items-start gap-10 px-4 pb-10 pt-2 sm:px-8 sm:pt-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-16">
        <aside className="hidden rounded-[2rem] border border-pink-100 bg-gradient-to-b from-pink-50/70 to-white p-10 text-center lg:block">
          <p className="text-sm font-bold tracking-wide text-pink-700">MYPIGGY FOR KIDS</p>
          <h2 className="mx-auto mt-4 max-w-sm text-4xl font-extrabold leading-tight tracking-tight text-teal-950">Your money.<br />Your goals.<br />Your progress.</h2>
          <p className="mx-auto mt-5 max-w-sm text-lg leading-relaxed text-slate-600">Keep track of your money, build your savings, and see how far you can go.</p>
          <img src={kidArtwork} alt="MyPiggy's pink piggy wearing a teal hoodie and holding a coin" width="320" height="320" className="mx-auto my-6 h-auto w-full max-w-[280px] object-contain" decoding="async" />
          <div className="border-t border-pink-100 pt-6">
            <p className="font-extrabold leading-relaxed text-teal-900">Real piggy bank. Digital tracking.<br />Lifelong money lessons.</p>
            <p className="mt-3 text-sm text-slate-500">Small steps today. Good habits for life.</p>
          </div>
        </aside>
        <div className="mx-auto w-full max-w-md">{children}</div>
      </main>
    </div>
  );
}
